<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>
<div class="main">
  <div class="content">
    <div class="icon-text">
      <div>
        <span style="color: black;font-weight: 500;font-size: 18px;"><img class="bell-icon"
            src="/assets/images/hand.png" style="margin-right: 3px;margin-bottom: 6px;" alt=""> Welcome</span><br>
        <span style="color: black;margin-left: 35px;">Have a nice day at work</span>
      </div>
      <div class="daterange">
        <!-- Toggle Switch -->
        <ng-container>
          <span class="mr-2" style="font-weight: 500;">All Outlets</span>
          <label class="switch mr-1">
            <input type="checkbox" [(ngModel)]="isActiveOutlet" (click)="outletToggle($event.target)">
            <span class="slider-outlet"></span>
          </label>
          <span class="mr-2" style="font-weight: 500;">Hyperlocal Outlets</span>
        </ng-container>

        <!-- Date Range Button -->
        <button class="header-btn" (click)="openDateRangePicker()">
          <img style="width: 12px;margin-left: 3px;margin-right: 8px;margin-bottom: 2px;"
            [src]="bucketurl + '/images/calender.png'" alt="">Date Range
        </button>
      </div>
    </div>
  </div>
  <div class="row date-display justify-content-end mb-3" style="margin-right:-5px">
    <div class="col-auto styled-date-box">
      <span class="date-label-dash" *ngIf="startDate">From:</span> <span class="date-value-dash">{{startDate |
        date:'dd-MMM-yyyy'}}</span>
      <span class="date-label-dash" *ngIf="endDate">To:</span> <span class="date-value-dash">{{endDate |
        date:'dd-MMM-yyyy'}}</span>
    </div>
  </div>
  <div class="filter-wrapper ml-1" *ngIf="[2, 6, 7].includes(roleId)">
    <div class="row justify-content-end">
      <div class="col-auto" *ngIf="roleId == 2">
        <ng-multiselect-dropdown [placeholder]="'Zonal Manager'" class="form-control head-multiselect"
          [settings]="zoneSettings" [data]="zonalList" [(ngModel)]="selectedZonalMgrs" (onSelect)="onZoneSelect($event)"
          (onDeSelect)="onZoneDeSelect($event)">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-auto" *ngIf="[2, 6].includes(roleId)">
        <ng-multiselect-dropdown [placeholder]="'Regional Manager'" class="form-control head-multiselect"
          [settings]="regionSettings" [data]="regionalList" [(ngModel)]="selectedRegionalMgrs"
          (onSelect)="onRegionSelect($event)" (onDeSelect)="onRegionDeSelect($event)"
          [disabled]="roleId === 2 && (!selectedZonalMgrs || selectedZonalMgrs.length === 0)"
          (click)="showErrorForRegion()">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-auto" *ngIf="[2, 6, 7].includes(roleId)">
        <ng-multiselect-dropdown [placeholder]="'Area Manager'" class="form-control head-multiselect"
          [settings]="areaSettings" [data]="areaList" [(ngModel)]="selectedAreaMgrs" (onSelect)="onAreaSelect($event)"
          (onDeSelect)="onAreaDeSelect($event)"
          [disabled]="(roleId === 2 || roleId === 6) && (!selectedRegionalMgrs || selectedRegionalMgrs.length === 0)"
          (click)="showErrorForArea()">
        </ng-multiselect-dropdown>
      </div>

      <div class="col-auto">
        <button class="btn blue-btn" type="submit" (click)="applyManagers()">Apply</button>
      </div>
      <div class="rotate-icon-container p-0 ml-1 mr-1" (click)="clearFilter(true)">
        <span class="rotate-icon" title="Clear Filter"></span>
      </div>
    </div>
  </div>
  <div class="card-container mr-1" *ngIf="![5, 6, 7, 8, 9, 10].includes(roleId)">
    <div class="card card-hover card-select" *ngIf="headerCards.length > 0">
      <div class="info-icon">
        <img class="info" src="/assets/images/info.png" alt="" [adaptivePosition]="false" container="body"
          placement='top' containerClass="tooltipContainer" [tooltip]="tooltipTemplate">
      </div>
      <ng-template #tooltipTemplate>The total number
        of enquiries moved to Lost on selected date range.
      </ng-template>
      <div class="card-item d-flex align-items-center">
        <span>
          <img class="mr-3 ml-2" style="width:50px" src="/assets/images/lost.png" alt="">
        </span>
        <div class="item-card-val">
          <span>Total Lost</span>
          <p>{{ totalLostInZones }}</p>
        </div>
        <!-- <div class="card-label">{{ card.percentage }}%</div> -->
      </div>
    </div>
    <div class="card card-hover card-select" *ngFor="let card of headerCards; let i = index; let last = last;"
      [ngClass]="{'selected-card': selectedCardIndex === i}" (click)="selectCard(i, card)">
      <div class="info-icon">
        <img class="info" src="/assets/images/info.png" alt="" [adaptivePosition]="false" container="body"
          [placement]="last ? 'left' : 'top'" containerClass="tooltipContainer" [tooltip]="tooltipTemplate">
      </div>
      <ng-template #tooltipTemplate>The number
        of enquiries moved to Lost till
        date within the selected date
        range in the Zone.
      </ng-template>
      <div class="card-item d-flex align-items-center">
        <span>
          <img class="mr-3 ml-2" [src]="getIcon(card.name)" alt="">
        </span>
        <div class="item-card-val">
          <span>{{ card.name }}</span>
          <p>{{ card.value }}</p>
        </div>
        <div class="card-label">{{ card.percentage }}%</div>
      </div>
    </div>
  </div>
  <div class="row">
    <!-- <div class="col p-2 ml-2 mr-1" >
      <div class="card card-hover">
        <div class="info-icon">
          <img class="info" src="/assets/images/info.png" alt="" 
              [adaptivePosition]="false" container="body" placement='left'
              containerClass="tooltipContainer" 
              [tooltip]="lostTemp">
        </div>
        <ng-template #lostTemp>The total number of enquiries lost.
        </ng-template>
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-1 ml-1" src="{{ bucketurl }}/images/better_offer_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Total Lost </span> <span *ngIf="roleId == 2">{{selectedZone?.name || ''}}</span>
            <p>{{totalLostCount ? totalLostCount :0}}</p>
          </div>
        </div>
      </div>
    </div> -->
    <div class="col p-2 ml-2 mr-1" *ngFor="let item of lostCardCounts; let last = last">
      <div class="card card-hover">
        <div class="info-icon">
          <img class="info" src="/assets/images/info.png" alt="" [adaptivePosition]="false" container="body"
            [placement]="last ? 'left' : 'top'" containerClass="tooltipContainer" [tooltip]="lostTemp">
        </div>
        <ng-template #lostTemp>The number of enquiries lost due to {{item?.reason}}
        </ng-template>
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-1 ml-1" src="{{ bucketurl }}/images/better_offer_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>{{ item.reason }}</span>
            <p>{{ item.count }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row justify-content-center">
    <div class="col p-2 ml-2 mr-1" [ngClass]="{'single-card': lostSubCards.length % 2 !== 0 && last}"
      *ngFor="let item of lostSubCards; let last = last">
      <div class="card card-hover">
        <div class="info-icon">
          <img class="info" src="/assets/images/info.png" alt="" [adaptivePosition]="false" container="body"
            [placement]="last ? 'left' : 'left'" containerClass="tooltipContainer" [tooltip]="lostTemp">
        </div>
        <ng-template #lostTemp>The number of enquiries lost due to {{item?.name}}.
        </ng-template>
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-1 ml-1" src="{{ bucketurl }}/images/better_offer_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>{{ item?.name?.length > 20 ? item?.name?.substring(0, 20) + '...' : item?.name }}</span>
            <p>{{ item.count }}</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!-- <div class="row">
    <div class="col p-2 ml-3">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/price_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Price</span>
            <p> {{lostCardCounts.price_concerns}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col p-2">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/competitor_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Competitor</span>
            <p>
              {{lostCardCounts.lost_to_competitor}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col p-2">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/willingness_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Willingness</span>
            <p>
              {{lostCardCounts.family_personal_decision}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="col p-2">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/better_offer_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Better Offer</span>
            <p>
              {{lostCardCounts.found_better_offer}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="col p-2">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/new_model_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>New Model</span>
            <p>
              {{lostCardCounts.will_wait_for_new_model}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col p-2">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/non_sales_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Non Sales</span>
            <p> {{lostCardCounts.non_sales}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="col p-2">
      <div class="lost-card card-hover">
        <div class="card-item d-flex align-items-center">
          <span>
            <img class="mr-2 ml-1" src="{{ bucketurl }}/images/others_dash.png" alt="Leads Icon">
          </span>
          <div class="item-card-val">
            <span>Others</span>
            <p> {{lostCardCounts.others}}</p>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>



<div class="row mb-2 mt-2 filter-section align-items-center">
  <div style="width:40px"><img class="chart-filter" src="/assets/images/chart_filter.png" alt=""> </div>
 <div class="col" *ngIf="roleId != 5 && roleId != 10 && roleId != 8 && roleId != 9">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnyGeographyChecked }"
        class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnyGeographyChecked }" src="/assets/images/zone.png" alt="">
          <span class="ml-2">Geography</span>
        </div>
        <i class="fas fa-angle-down"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="mt-1 mr-1 ml-1">
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTerm"
            (keyup)="filterDropdownData()" />
        </div>
        <!-- Zones -->
        <li class="dropdown-submenu" *ngFor="let zone of filteredData; let zoneIndex = index">
          <div class="dropdown-submenu mt-1" *ngIf="zoneIndex == 0">
            <div class="dropdown-item d-flex justify-content-between align-items-center">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="zone_check_all" [(ngModel)]="selectAllZoneChecked"
                  (change)="onZoneCheckAll($event.target)">
                <img src="/assets/images/zone.png" class=" ml-2" alt="">
                <label class="form-check-label" for="zone_check_all">Select All
                </label>
              </div>
            </div>
            <hr style="margin:1px">
          </div>
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="zone{{zone.zone_id}}"
                (change)="onZoneCheck($event.target, zone.zone_id)" [(ngModel)]="zone.checked">
              <img src="/assets/images/zone.png" class="ml-2" alt="">
              <label class="form-check-label" for="zone{{zone.zone_id}}">{{ zone.zone_name }}
                <!-- <div class="form-text">{{ zone.Zone_Manager }}</div> -->
              </label>

            </div>
            <!-- <a class="dropdown-toggle" (click)="toggleDropdown($event)"></a> -->
            <i class="fas fa-angle-right" style="font-size:13px" *ngIf="zone?.States?.length > 0"></i>
          </div>
          <!-- States inside Zone -->
          <ul class="dropdown-menu" *ngIf="zone?.States?.length > 0">
            <li class="dropdown-submenu mt-1">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="region_check_all"
                    [(ngModel)]="zone.selectALlStateChecked"
                    (change)="onStateCheckAll($event.target, zone.zone_id, zone)">
                  <img src="/assets/images/zone.png" class=" ml-2" alt="">
                  <label class="form-check-label" for="region_check_all">Select All</label>
                </div>
              </div>
            </li>
            <hr style="margin:1px">
            <li class="dropdown-submenu" *ngFor="let state of zone.States">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="state{{state.state_id}}"
                    (change)="onStateCheck($event.target, zone.zone_id, state.state_id)" [(ngModel)]="state.checked">
                  <img src="/assets/images/zone.png" class="ml-2" alt="">
                  <label class="form-check-label" for="state{{state.state_id}}">
                    {{ state.state_name }}
                  </label>
                </div>
                <i class="fas fa-angle-right" style="font-size:13px" *ngIf="state?.Regions?.length > 0"></i>
              </div>

              <!-- Regions inside State -->
              <ul class="dropdown-menu" *ngIf="state?.Regions?.length > 0">
                <li class="dropdown-submenu mt-1">
                  <div class="dropdown-item d-flex justify-content-between align-items-center">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="region_check_all"
                        [(ngModel)]="state.selectAllChecked"
                        (change)="onRegionCheckAll($event.target, zone.zone_id, state.state_id, state)">
                      <img src="/assets/images/zone.png" class=" ml-2" alt="">
                      <label class="form-check-label" for="region_check_all">Select All</label>
                    </div>
                  </div>
                </li>
                <hr style="margin:1px">
                <li class="dropdown-submenu" *ngFor="let region of state.Regions">
                  <div class="dropdown-item d-flex justify-content-between align-items-center">
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" id="region{{region.region_id}}"
                        (change)="onRegionCheck($event.target, zone.zone_id,  state.state_id,region.region_id)"
                        [(ngModel)]="region.checked">
                      <img src="/assets/images/zone.png" class=" ml-2" alt="">
                      <label class="form-check-label" for="region{{region.region_id}}">
                        {{ region.region_name }}
                      </label>
                    </div>
                    <i class="fas fa-angle-right" style="font-size:13px" *ngIf="region?.ParentDealers?.length > 0"></i>
                  </div>

                  <!-- Areas inside Region -->
                  <ul class="dropdown-menu" *ngIf="region?.ParentDealers?.length > 0">
                    <div class="sub-list">
                      <li class="dropdown-submenu mt-1">
                        <div class="dropdown-item d-flex justify-content-between align-items-center">
                          <div class="form-check">
                            <input type="checkbox" class="form-check-input" id="area_check_all"
                              [checked]="region.selectAllAreasChecked"
                              (change)="onAreaCheckAll($event.target, zone.zone_id, state.state_id, region.region_id)">
                            <img src="/assets/images/zone.png" class=" ml-2" alt="">
                            <label class="form-check-label" for="area_check_all">Select All</label>
                          </div>
                        </div>
                      </li>
                      <hr style="margin:1px">
                      <li class="dropdown-submenu" *ngFor="let parent of region.ParentDealers">
                          <ng-container *ngFor="let outlet of parent.Outlets">
                            <div class="dropdown-item">
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input two-labels"
                                  id="outlet{{outlet.outlet_id}}" [(ngModel)]="outlet.checked"
                                  (change)="onAreaCheck($event.target, zone.zone_id, state.state_id, region.region_id, outlet.outlet_id)">
                                <img src="/assets/images/zone.png"  class="ml-2" alt="">
                                <label class="form-check-label" for="outlet{{outlet.outlet_id}}">
                                  {{ outlet.outlet_name }} ({{ outlet.outlet_code }})
                                </label>
                              </div>
                            </div>
                        </ng-container>
                      </li>
                    </div>
                  </ul>
                </li>
              </ul>
            </li>
          </ul>

        </li>
        <li class="dropdown-submenu" *ngIf="filteredData.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">Not found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div>  
  <!-- <div class="col" *ngIf="roleId == 8 || roleId == 9">
    <div class="dropdown">
      <button class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img src="/assets/images/outlet-dropdown.png" alt="">
          <span class="ml-2">Dealer</span>
        </div>
        <i class="fas fa-angle-down"></i>
      </button>
      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="mt-1 mr-1 ml-1">
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchTermDealer"
            (keyup)="filterDealerData()" />
        </div>

        <li class="dropdown-submenu" *ngFor="let dealer of filteredDealerData.slice(0,10); let dealerIndex = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="dealer{{dealer.parent_dealer_id}}"  [disabled] = "!isAnyAreaChecked && ![8, 9].includes(roleId)"
                (change)="onDealerCheck($event.target, dealer.parent_dealer_id)" [(ngModel)]="dealer.checked">
              <img src="/assets/images/outlet-dropdown.png" class="ml-2" alt="">
              <label class="form-check-label" for="dealer{{dealer.parent_dealer_id}}">{{ dealer.parent_dealer_name }}
                ({{ dealer.dealer_code}})
              </label>
            </div>
            <i class="fas fa-angle-right" style="font-size:13px" *ngIf="dealer?.Outlets?.length > 0"></i>
          </div>
          <ul class="dropdown-menu" *ngIf="dealer?.Outlets?.length > 0">
            <li class="dropdown-submenu" *ngFor="let outlet of dealer.Outlets; let outletIndex = index">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="outlet{{outlet.outlet_id}}"  [disabled] = "!isAnyAreaChecked && ![8, 9].includes(roleId)"
                    (change)="onOutletCheck($event.target, dealer.parent_dealer_id, outlet.outlet_id)"
                    [(ngModel)]="outlet.checked">
                  <img src="/assets/images/outlet-dropdown.png" class=" ml-2" alt="">
                  <label class="form-check-label" for="outlet{{outlet.outlet_id}}">{{ outlet.outlet_name }} ({{
                    outlet.outlet_code}}) 
                  </label>
                </div>
              </div>
            </li>
          </ul>
        </li>
        <li class="dropdown-submenu" *ngIf="filteredDealerData.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">Not found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div> -->
  

  <div class="col">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnySourceChecked }"
        class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnySourceChecked }" src="/assets/images/source.png" alt="">
          <span class="ml-2">Source</span>
        </div><i class="fas fa-angle-down"></i>
      </button>


      <ul class="dropdown-menu">
        <li class="dropdown-submenu mt-1" *ngFor="let leadsource of filteredDataSource; let sourceIndex = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center" *ngIf="sourceIndex == 0">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="source_check_all" [(ngModel)]="selectAllSourceChecked"
                (change)="onSourceCheckAll($event.target)">
              <img src="/assets/images/source.png" class=" ml-2" alt="">
              <label class="form-check-label" for="source_check_all">Select All
              </label>
            </div>
          </div>
        </li>
        <hr style="margin:1px">
        <li class="dropdown-submenu" *ngFor="let leadsource of filteredDataSource; let sourceIndex = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="ls_{{leadsource.id}}"
                (change)="onSourceCheck($event.target, leadsource.base_lead_source_id, leadsource.id)"
                [(ngModel)]="leadsource.checked">
              <img src="/assets/images/source.png" class="ml-2" alt="">
              <label class="form-check-label" for="ls_{{leadsource.id}}">{{ leadsource.lead_source }}</label>
            </div>
            <i class="fas fa-angle-right" style="font-size:13px" *ngIf="leadsource?.lead_sub_sources?.length > 0"></i>
          </div>
          <ul class="dropdown-menu" *ngIf="leadsource?.lead_sub_sources?.length > 0">
            <li class="dropdown-submenu mt-1">
              <div class="dropdown-item d-flex justify-content-between align-items-center">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" id="sub_source_check_all"
                    [(ngModel)]="leadsource.selectAllSubSourceChecked"
                    (change)="onSubSourceCheckAll($event.target, leadsource.base_lead_source_id, leadsource.id)">
                  <img src="/assets/images/source.png" class=" ml-2" alt="">
                  <label class="form-check-label" for="sub_source_check_all">Select All
                  </label>
                </div>
              </div>
            </li>
            <hr style="margin:1px">
            <div class="sub-list">
              <li class="dropdown-submenu"
                *ngFor="let subsource of leadsource.lead_sub_sources; let subSourceIndex = index">
                <div class="dropdown-item d-flex justify-content-between align-items-center">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="ss_{{subsource.id}}"
                      (change)="onSubsourceCheck($event.target, leadsource.base_lead_source_id, leadsource.id , subsource.id)"
                      [(ngModel)]="subsource.checked">
                    <img src="/assets/images/source.png" class="ml-2" alt="">
                    <label class="form-check-label" for="ss_{{subsource.id}}">{{ subsource.lead_sub_source
                      }}</label>
                  </div>
                </div>
              </li>
            </div>
          </ul>
        </li>
        <li class="dropdown-submenu" *ngIf="filteredDataSource.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">No data found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="col">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnyCategoryChecked }"
        class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnyCategoryChecked }" src="/assets/images/product.png" alt="">
          <span class="ml-2 mr-2">Product Category</span>
        </div><i class="fas fa-angle-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <li class="dropdown-submenu mt-1">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="category_check_all"
                [(ngModel)]="selectAllCategoryChecked" (change)="onCategoryCheckAll($event.target)">
              <img src="/assets/images/product.png" class=" ml-2" alt="">
              <label class="form-check-label" for="category_check_all">Select All
              </label>
            </div>
          </div>
        </li>
        <hr style="margin:1px">
        <li class="dropdown-submenu" *ngFor="let data of categoryData; let i = index">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="cat_{{data.category_id}}" [(ngModel)]="data.checked"
                (change)="onCategoryCheck($event.target, data.category_id)">
              <img src="/assets/images/product.png" class="ml-2" alt="">
              <label class="form-check-label" for="cat_{{data.category_id}}">{{ data.category_name }}</label>
            </div>
          </div>
        </li>
        <li class="dropdown-submenu" *ngIf="categoryData.length == 0">
          <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
            <span style="font-size: 13px;">No data found!</span>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="col">
    <div class="dropdown">
      <button [ngClass]="{ 'btn-filter-selected': isAnyModelChecked }"
        class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img [ngClass]="{ 'white-icon': isAnyModelChecked }" src="/assets/images/product.png" alt="">
          <span class="ml-2">Product Model</span>
        </div><i class="fas fa-angle-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <li class="dropdown-submenu mt-1">
          <div class="dropdown-item d-flex justify-content-between align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="model_check_all" [(ngModel)]="selectAllModelChecked"
                (change)="onModelCheckAll($event.target)">
              <img src="/assets/images/product.png" class=" ml-2" alt="">
              <label class="form-check-label" for="model_check_all">Select All
              </label>
            </div>
          </div>
        </li>
        <hr style="margin:1px">
        <div class="sub-list">
          <li class="dropdown-submenu" *ngFor="let data of filteredModelData;let i = index;">
            <div class="dropdown-item d-flex justify-content-between align-items-center">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="model_{{data.model_id}}" [(ngModel)]="data.checked"
                  (change)="onModelCheck($event.target)">
                <img src="/assets/images/product.png" class="ml-2" alt="">
                <label class="form-check-label" for="model_{{data.model_id}}">{{ data.model_name }}</label>
              </div>
            </div>
          </li>
          <li class="dropdown-submenu" *ngIf="filteredModelData.length == 0">
            <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
              <span style="font-size: 13px;">No data found!</span>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div>



  <!-- <div class="col">
    <div class="dropdown">
      <button class="btn geo-btn dropdown-toggle d-flex justify-content-between align-items-center" type="button"
        id="geographyDropdown" data-bs-toggle="dropdown" aria-expanded="false">
        <div class="d-flex align-items-center">
          <img src="/assets/images/status.png" alt="">
          <span class="ml-2">Status</span>
        </div><i class="fas fa-angle-down"></i>
      </button>

      <ul class="dropdown-menu" aria-labelledby="geographyDropdown">
        <div class="sub-list">
          <li class="dropdown-submenu" *ngFor="let data of statusData;let i=index">
            <div class="dropdown-item d-flex justify-content-between align-items-center">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="status_{{data.id}}" [(ngModel)]="data.checked"
                  (change)="onStatusCheck($event.target, data.id)">
                <img src="/assets/images/status.png" class="ml-2" alt="">
                <label class="form-check-label" for="status_{{data.id}}">{{ data.dms_stage_name }}</label>
              </div>
            </div>
          </li>
          <li class="dropdown-submenu" *ngIf="statusData.length == 0">
            <div class="dropdown-item d-flex justify-content-between align-items-center mb-2">
              <span style="font-size: 13px;">No data found!</span>
            </div>
          </li>
        </div>
      </ul>
    </div>
  </div> -->
  <div class="col-1 p-0" style="width: auto;">
    <button class="btn blue-btn" type="submit" (click)="applyFilter()">Apply</button>
  </div>
  <div class="rotate-icon-container" (click)="clearFilter(false)">
    <span class="rotate-icon" title="Clear Filter"></span>
  </div>
  <!-- <div style="width:35px;cursor: pointer;" (click)="clearFilter()"> <img src="/assets/images/close.png"
      style="width: 13px;" alt="">
  </div> -->
</div>


<!-- Carousel Section for Charts -->
<div class="pie-background mt-2 mb-1 row">
  <div class="col-8" style="width:68%;">
    <div class="ml-2 mt-1">
     <h1 class="chart-head" *ngIf="roleId != 8 && roleId != 9 && roleId != 5 && roleId != 10">Geography Performance</h1>
        <h1 class="chart-head" *ngIf="roleId == 8 || roleId == 9">Dealer Performance</h1>
         <h1 class="chart-head" *ngIf="roleId == 5 ||  roleId == 10 ">Outlet Performance</h1>
    </div>
    <div  #chartCarousel id="chartCarousel" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner">
        <ng-container *ngFor="let chart of chartsData; let i = index">
          <ng-container *ngIf="i % 2 === 0">
            <div class="carousel-item" [class.active]="i === 0 && i % 2 === 0">
              <!-- Only first even item has 'active' -->
              <div class="row" *ngIf="i % 2 === 0">
                <!-- Display charts in pairs  *ngIf="chartsData[i + 1]; else singleChart"-->
                <div class="col-6 chart-body" *ngIf="chartsData[i + 1]; else singleChart;">
                  <p-chart style="width: 240px !important;height: 240px !important;" width="240" height="240"
                    type="doughnut" class="pie-chart" [data]="chart.data" [options]="chart.options"></p-chart>
                  <div class="chart-label mt-2">{{ chart.options.title }}
                    <div class="chart-sub-label" *ngIf="chart.options.subText1">
                      {{ chart.options.subText1 }}
                    </div>
                  </div>
                </div>

                <div class="col-6 chart-body" *ngIf="chartsData[i + 1]">
                  <p-chart style="width: 240px !important;height: 240px !important;" width="240" height="240"
                    type="doughnut" class="pie-chart" [data]="chartsData[i + 1].data"
                    [options]="chartsData[i + 1].options"></p-chart>
                  <div class="chart-label mt-2">
                    {{ chartsData[i + 1].options.title }}
                    <div class="chart-sub-label" *ngIf="chartsData[i + 1].options.subText1">
                      {{ chartsData[i + 1].options.subText1 }}
                    </div>
                  </div>
                </div>
                <ng-template #singleChart>
                  <div class="col-12 chart-body">
                    <p-chart style="width: 240px !important; height: 240px !important;" width="240" height="240"
                      type="doughnut" class="pie-chart" [data]="chart.data" [options]="chart.options"></p-chart>
                    <div class="chart-label mt-1">{{ chart.options.title }}
                      <div class="chart-sub-label" *ngIf="chart.options.subText1">
                        {{ chart.options.subText1 }}
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="chartsData.length == 0">
          <div class="no-data-available">
            <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
          </div>
        </ng-container>
      </div>

      <ng-container *ngIf="chartsData.length > 2">
        <!-- Carousel Controls -->
        <a class="carousel-control-prev" style="margin-left: -25px !important;" (click)="prevSlide()" role="button" [class.disabled]="currentIndex === 0"
          data-slide="prev">
          <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span>
      <span class="sr-only">Previous</span> -->
          <img src="/assets/images/prev-btn.png" alt="">
        </a>
        <a class="carousel-control-next" style="margin-right: -25px !important;" (click)="nextSlide()" role="button" [class.disabled]="currentIndex === totalSlides - 1"
          data-slide="next">
          <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span>
      <span class="sr-only">Next</span> -->
          <img src="/assets/images/next-btn.png" alt="">
        </a>
      </ng-container>
    </div>
  </div>
  <div class="col-4 leads-status-box">
    <div *ngIf="isOneOutlet" class="avg-toggle-buttons d-flex justify-content-between align-items-center">
      <button type="button" class="avg-button" [class.active]="geographySelectedAvg === 'national'"
        (click)="geographySelectAvg('national')">
        National Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="nationalTemplate" />
      </button>
      <ng-template #nationalTemplate>
        The National Average is the total lost enquiries of selected geography PAN india per Total outlets in Pan India.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="geographySelectedAvg === 'zonal'"
        (click)="geographySelectAvg('zonal')">
        Zonal Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="zonalTemplate" />
      </button>
      <ng-template #zonalTemplate>
        The Zonal Average is the total lost enquiries of selected geography based on selected outlets zone per Total
        outlets in selected outlets zone.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="geographySelectedAvg === 'state'"
        (click)="geographySelectAvg('state')">
        State Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The State Average is the total lost enquiries of selected geography based on selected outlets states per Total
        outlets in selected outlets states </ng-template>
    </div>
    <div class="status-table">
      <table class="table right-table">
        <thead class="table-head">
          <tr>

            <!-- If avg selected, split into 2 cols each -->
            <ng-container *ngIf="geographySelectedAvg; else normalGeoHeaderRow">
              <th rowspan="2" style="vertical-align: middle; text-align: left;" class="table-head"> <img
                  src="/assets/images/geo-table.png" class="mr-1" alt="">
                <ng-container *ngIf="roleId != 5 && roleId != 10">
              <span *ngIf="isGeography">Geography</span>
              <span *ngIf="!isGeography">Dealer</span>
              </ng-container>
               <ng-container *ngIf="roleId == 5 ||  roleId == 10 ">
              <span >Outlet</span>
              </ng-container>
              </th>
              <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                <img src="/assets/images/leads-table.png" alt=""> Enquiries
              </th>
              <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                <img src="/assets/images/hot-table.png" alt=""> {{geographySelectedField}}(%)
              </th>
            </ng-container>
          </tr>

          <!-- Sub-header row when avg is selected -->
          <tr *ngIf="geographySelectedAvg">
            <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">Total
            </th>
            <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
              Average</th>
            <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">Total
            </th>
            <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
              Average</th>
          </tr>

          <!-- Normal header row when nothing selected -->
          <ng-template #normalGeoHeaderRow>
            <th class="table-head"> <img src="/assets/images/geo-table.png" class="mr-1" alt="">
                 <ng-container *ngIf="roleId != 5 && roleId != 10">
              <span *ngIf="isGeography">Geography</span>
              <span *ngIf="!isGeography">Dealer</span>
              </ng-container>
               <ng-container *ngIf="roleId == 5 ||  roleId == 10 ">
              <span >Outlet</span>
              </ng-container>
            </th>
            <th class="table-head"><img src="/assets/images/leads-table.png" alt=""> Enquiries</th>
            <th class="table-head"><img src="/assets/images/hot-table.png" alt=""> {{geographySelectedField}}(%)</th>
          </ng-template>
        </thead>
        <tbody class="table-body">
          <ng-container *ngIf="loadingTable1; else loadedContent">
            <ng-container *ngIf="!geographySelectedAvg">
              <tr *ngFor="let i of [1, 2, 3, 4]">
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
              </tr>
            </ng-container>
            <ng-container *ngIf="geographySelectedAvg">
              <tr *ngFor="let i of [1, 2, 3, 4]">
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
              </tr>
            </ng-container>
          </ng-container>

          <ng-template #loadedContent>
            <tr *ngFor="let zone of geographyStatus">
              <td class="tabel-cell">{{ zone.name }}</td>
              <ng-container *ngIf="geographySelectedAvg; else normalGeoRow">
                <td style="text-align: center;">{{ zone.leads }}</td>
                <td style="text-align: center;">{{ zone.enqAverage }}</td>
                <td style="text-align: center;">{{ zone.count }} <span class="table-percentage"
                    *ngIf="zone.percentage !== 0">({{ zone.percentage }}%)</span></td>
                <td style="text-align: center;">{{ zone.stageAverage }} <span class="table-percentage"
                    *ngIf="zone.stageAveragePer !== 0">({{ zone.stageAveragePer }}%)</span></td>
              </ng-container>
              <ng-template #normalGeoRow>
                <td class="tabel-cell" style="text-align: center;">{{ zone.leads }}</td>
                <td class="tabel-cell-per" style="text-align: center;">
                  {{ zone.count }}
                  <span class="table-percentage" *ngIf="zone.percentage !== 0">({{ zone.percentage }}%)</span>
                </td>
              </ng-template>
            </tr>
            <tr *ngIf="geographyStatus?.length === 0">
              <td *ngIf="!geographySelectedAvg" class="tabel-cell" colspan="3" style="text-align: center;">No data
                available!</td>
              <td *ngIf="geographySelectedAvg" class="tabel-cell" colspan="5" style="text-align: center;">No data
                available!</td>
            </tr>
          </ng-template>
        </tbody>
        <tfoot class="table-footer">
          <ng-container *ngIf="loadingTable1; else loadedFooter">
            <ng-container *ngIf="!geographySelectedAvg">
              <tr>
                <td *ngFor="let i of [1, 2, 3]">
                  <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '10px' }"></ngx-skeleton-loader>
                </td>
              </tr>
            </ng-container>
            <ng-container *ngIf="geographySelectedAvg">
              <tr>
                <td *ngFor="let i of [1, 2, 3, 4, 5]">
                  <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '10px' }"></ngx-skeleton-loader>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-template #loadedFooter>
            <tr *ngIf="geographyStatus?.length > 0" class="table-total-row">
              <td class="tabel-cell" style="font-weight: bold; font-size: 12px; background-color: #edf4f9;">Total</td>
              <ng-container *ngIf="geographySelectedAvg; else normalGeoFooter">
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{geographyTotalLeads}}</td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{geographyTotalLeadAvg}}</td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{geographyTotalCounts}}<span class="table-percentage"> ({{geographyStagePercentage}}%)</span></td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{geographyTotalCountAvg}}<span class="table-percentage"> ({{geographyTotalCountAvgPer}}%)</span></td>
              </ng-container>
              <ng-template #normalGeoFooter>
                <td class="tabel-cell"
                  style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{ geographyTotalLeads }}
                </td>
                <td class="tabel-cell-per"
                  style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{ geographyTotalCounts }}
                  <span class="table-percentage">({{ geographyStagePercentage }}%)</span>
                </td>
              </ng-template>
            </tr>
          </ng-template>
        </tfoot>
      </table>
    </div>
  </div>

</div>
<div class="graph row">
  <div class="col-8" style="width:68%">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="chart-head">Product Category Performance</h1>
      <div class="comparison d-flex align-items-cente">
        <span *ngIf="!visibleCategoryMonth" class="comparebtn" (click)="onclick()">Compare
          <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
        </span>
        <div *ngIf="visibleCategoryMonth" class="datepick d-flex align-items-cente">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpCategoryStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="categoryStartMonth" placeholder="Select Month">
          </div>
          <span class="m-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpCategoryEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="categoryEndMonth" placeholder="Select Month">
          </div>
          <div>
            <button class="btn compare" type="button" (click)="compareCategory()">
              <i class="fa fa-exchange-alt" title="Compare"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearCategory()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="productCategoryOptions.series.length > 0">
      <apx-chart #categoryChart [series]="productCategoryOptions.series!" [chart]="productCategoryOptions.chart!"
        [dataLabels]="productCategoryOptions.dataLabels!" [plotOptions]="productCategoryOptions.plotOptions!"
        [yaxis]="productCategoryOptions.yaxis!" [xaxis]="productCategoryOptions.xaxis!"
        [legend]="productCategoryOptions.legend!" [colors]="productCategoryOptions.colors!"
        [grid]="productCategoryOptions.grid!"></apx-chart>
      <div *ngIf="productCategoryOptions.xaxis?.categories?.flat()?.includes('Not Mapped')" style="font-size:10px;"
        class="ml-2 mr-2"> <span>Not Mapped: Count of unassigned category enquiries from calls and website forms. To be
          assigned to DSE after Digital Desk qualification.</span></div>
    </ng-container>
    <ng-container *ngIf="productCategoryOptions.series.length == 0">
      <div class="no-data-available">
        <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
      </div>
    </ng-container>
  </div>
  <div class="col-4 leads-status-box">
    <div *ngIf="isOneOutlet" class="avg-toggle-buttons d-flex justify-content-between align-items-center">
      <button type="button" class="avg-button" [class.active]="categorySelectedAvg === 'national'"
        (click)="categorySelectAvg('national')">
        National Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="nationalTemplate" />
      </button>
      <ng-template #nationalTemplate>
        The National Average is the total lost enquiries of selected category PAN india per Total outlets in Pan India.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="categorySelectedAvg === 'zonal'"
        (click)="categorySelectAvg('zonal')">
        Zonal Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="zonalTemplate" />
      </button>
      <ng-template #zonalTemplate>
        The Zonal Average is the total lost enquiries of selected category based on selected outlets zone per Total
        outlets in selected outlets zone.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="categorySelectedAvg === 'state'"
        (click)="categorySelectAvg('state')">
        State Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The State Average is the total lost enquiries of selected category based on selected outlets states per Total
        outlets in selected outlets states </ng-template>
    </div>
    <div class="status-table">
      <div class="table-container">
        <table class="table right-table">
          <thead class="table-head">
            <tr>
              <!-- If avg selected, split into 2 cols each -->
              <ng-container *ngIf="categorySelectedAvg; else normalCatHeaderRow">
                <th rowspan="2" style="vertical-align: middle; text-align: left;border: 1px solid #ccc;"
                  class="table-head"> <img src="/assets/images/category-table.png" alt=""> Category</th>

                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/leads-table.png" alt=""> Enquiries
                </th>
                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/hot-table.png" alt=""> {{categorySelectedField}}(%)
                </th>
              </ng-container>
            </tr>
            <tr *ngIf="categorySelectedAvg">
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
            </tr>
            <ng-template #normalCatHeaderRow>
              <th class="table-head"> <img src="/assets/images/category-table.png" alt=""> Category</th>
              <th class="table-head"><img src="/assets/images/leads-table.png" alt=""> Enquiries</th>
              <th class="table-head"><img src="/assets/images/hot-table.png" alt=""> {{categorySelectedField}}(%)</th>
            </ng-template>
          </thead>
          <tbody class="table-body">
            <ng-container *ngIf="loadingTable2; else loadedContentCategory">
              <ng-container *ngIf="!categorySelectedAvg">
                <tr *ngFor="let i of [1, 2, 3, 4]">
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                </tr>
              </ng-container>
              <ng-container *ngIf="categorySelectedAvg">
                <tr *ngFor="let i of [1, 2, 3, 4]">
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #loadedContentCategory>
              <tr *ngFor="let data of categoryStatus">
                <td>
                  <span>{{data.name}} </span>
                  <span *ngIf="data.name == 'Not Mapped'">
                    <img style="width:12px;cursor:pointer" src="/assets/images/info.png" alt=""
                      [adaptivePosition]="false" container="body" placement="top" containerClass="tooltipContainer"
                      [tooltip]="notmap"></span>
                  <ng-template #notmap>Count of unassigned category enquiries from calls and website forms. To be
                    assigned to DSE after Digital Desk qualification.
                  </ng-template>
                </td>
                <ng-container *ngIf="categorySelectedAvg; else normalCatRow">
                  <td style="text-align: center;">{{ data.leads }}</td>
                  <td style="text-align: center;">{{ data.enqAverage }}</td>
                  <td style="text-align: center;">{{ data.count }} <span class="table-percentage"
                      *ngIf="data.percentage !== 0">({{ data.percentage }}%)</span></td>
                  <td style="text-align: center;">{{ data.stageAverage }} <span class="table-percentage"
                      *ngIf="data.stageAveragePer !== 0">({{ data.stageAveragePer }}%)</span></td>
                </ng-container>
                <ng-template #normalCatRow>
                  <td style="text-align: center;">{{data.leads}}</td>
                  <td class="tabel-cell-per" style="text-align: center;">{{data.count}} <span class="table-percentage"
                      *ngIf="data.percentage !== 0">({{ data.percentage }}%)</span></td>
                </ng-template>
              </tr>
              <tr *ngIf="categoryStatus?.length === 0">
                <td *ngIf="!categorySelectedAvg" class="tabel-cell" colspan="3" style="text-align: center;">No data
                  available!</td>
                <td *ngIf="categorySelectedAvg" class="tabel-cell" colspan="5" style="text-align: center;">No data
                  available!</td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot class="table-footer" *ngIf="categoryStatus?.length > 0">
            <tr class="table-total-row">
              <td class="tabel-cell" style="font-weight: bold;font-size: 12px;background-color: #edf4f9;">Total</td>
              <ng-container *ngIf="categorySelectedAvg; else normalCatFooter">
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{categoryTotalLeads}}</td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{categoryTotalLeadAvg}}</td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{categoryTotalCounts}}<span class="table-percentage"> ({{categoryStagePercentage}}%)</span></td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{categoryTotalCountAvg}}<span class="table-percentage"> ({{categoryTotalCountAvgPer}}%)</span></td>
              </ng-container>
              <ng-template #normalCatFooter>
                <td class="tabel-cell"
                  style="text-align: center; font-weight: bold;font-size: 12px;background-color: #edf4f9;">{{
                  categoryTotalLeads }}</td>
                <td class="tabel-cell-per"
                  style="text-align: center; font-weight: bold;font-size: 12px;background-color: #edf4f9;">{{
                  categoryTotalCounts }}<span class="table-percentage"> ({{categoryStagePercentage}}%)</span></td>
              </ng-template>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="graph row">
  <div class="col-8" style="width:68%">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="chart-head">Product Model Performance</h1>
      <div class="comparison d-flex align-items-cente">
        <span *ngIf="!visibleModelMonth" class="comparebtn" (click)="onclick2()">Compare
          <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
        </span>
        <div *ngIf="visibleModelMonth" class="datepick d-flex align-items-cente">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpModelStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="modelStartMonth" placeholder="Select Month">
          </div>
          <span class="m-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpModelEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="modelEndMonth" placeholder="Select Month">
          </div>
          <div>
            <button class="btn compare" type="button" (click)="compareModel()">
              <i class="fa fa-exchange-alt" title="Compare"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearModel()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="productModelOptions.series.length > 0">
      <div style="overflow-x: auto; width: 100%; scroll-behavior: smooth;">
        <apx-chart #modelChart [series]="productModelOptions.series!" [chart]="productModelOptions.chart!"
          [dataLabels]="productModelOptions.dataLabels!" [plotOptions]="productModelOptions.plotOptions!"
          [yaxis]="productModelOptions.yaxis!" [xaxis]="productModelOptions.xaxis!"
          [legend]="productModelOptions.legend!" [colors]="productModelOptions.colors!"
          [grid]="productModelOptions.grid!"></apx-chart>
      </div>
      <div *ngIf="productModelOptions.xaxis?.categories?.flat()?.includes('Not Mapped')" style="font-size:10px;"
        class="ml-2 mt-2 mr-3"> <span>Not Mapped: Count of unassigned model enquiries from calls and website forms. To
          be assigned to DSE after Digital Desk qualification.</span></div>
    </ng-container>
    <ng-container *ngIf="productModelOptions.series.length == 0">
      <div class="no-data-available">
        <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
      </div>
    </ng-container>
  </div>
  <div class="col-4 leads-status-box">
    <div *ngIf="isOneOutlet" class="avg-toggle-buttons d-flex justify-content-between align-items-center">
      <button type="button" class="avg-button" [class.active]="modelSelectedAvg === 'national'"
        (click)="modelSelectAvg('national')">
        National Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="nationalTemplate" />
      </button>
      <ng-template #nationalTemplate>
        The National Average is the total lost enquiries of selected model PAN india per Total outlets in Pan India.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="modelSelectedAvg === 'zonal'"
        (click)="modelSelectAvg('zonal')">
        Zonal Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="zonalTemplate" />
      </button>
      <ng-template #zonalTemplate>
        The Zonal Average is the total lost enquiries of selected model based on selected outlets zone per Total outlets
        in selected outlets zone.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="modelSelectedAvg === 'state'"
        (click)="modelSelectAvg('state')">
        State Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The State Average is the total enquiries of selected Model based on selected outlets states per total outlets in
        selected outlets states
      </ng-template>
    </div>
    <div class="status-table">
      <div class="table-container">
        <table class="table right-table">
          <thead class="table-head">
            <tr>

              <!-- If avg selected, split into 2 cols each -->
              <ng-container *ngIf="modelSelectedAvg; else normalHeaderRow">
                <th rowspan="2" style="vertical-align: middle; text-align: left;border: 1px solid #ccc;"
                  class="table-head"> <img src="/assets/images/model_table.png" alt=""> Model</th>

                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/leads-table.png" alt=""> Enquiries
                </th>
                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/hot-table.png" alt=""> {{modelSelectedField}}(%)
                </th>
              </ng-container>
            </tr>

            <!-- Sub-header row when avg is selected -->
            <tr *ngIf="modelSelectedAvg">
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
            </tr>

            <!-- Normal header row when nothing selected -->
            <ng-template #normalHeaderRow>
              <th class="table-head"> <img src="/assets/images/model_table.png" alt=""> Model</th>
              <th class="table-head"><img src="/assets/images/leads-table.png" alt=""> Enquiries</th>
              <th class="table-head"><img src="/assets/images/hot-table.png" alt=""> {{modelSelectedField}}(%)</th>
            </ng-template>
          </thead>
          <tbody class="table-body">
            <ng-container *ngIf="loadingTable3; else loadedContentModel">
              <ng-container *ngIf="!modelSelectedAvg">
                <tr *ngFor="let i of [1, 2, 3, 4]">
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                </tr>
              </ng-container>
              <ng-container *ngIf="modelSelectedAvg">
                <tr *ngFor="let i of [1, 2, 3, 4]">
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #loadedContentModel>
              <tr *ngFor="let data of modelStatus">
                <td class="tabel-cell">{{data.name}}</td>

                <ng-container *ngIf="modelSelectedAvg; else normalRow">
                  <td style="text-align: center;">{{ data.leads }}</td>
                  <td style="text-align: center;">{{ data.enqAverage }}</td>
                  <td style="text-align: center;">{{ data.count }} <span class="table-percentage"
                      *ngIf="data.percentage !== 0">({{ data.percentage }}%)</span></td>
                  <td style="text-align: center;">{{ data.stageAverage }} <span class="table-percentage"
                      *ngIf="data.stageAverage !== 0">({{ data.stageAveragePer }}%)</span></td>
                </ng-container>

                <ng-template #normalRow>
                  <td class="tabel-cell" style="text-align: center;">{{ data.leads }}</td>
                  <td class="tabel-cell-per" style="text-align: center;">
                    {{ data.count }}
                    <span class="table-percentage" *ngIf="data.percentage !== 0">({{ data.percentage }}%)</span>
                  </td>
                </ng-template>
              </tr>
              <tr *ngIf="modelStatus?.length === 0">
                <td *ngIf="!modelSelectedAvg" class="tabel-cell" colspan="3" style="text-align: center;">No data
                  available!</td>
                <td *ngIf="modelSelectedAvg" class="tabel-cell" colspan="5" style="text-align: center;">No data
                  available!</td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot class="table-footer" *ngIf="modelStatus?.length > 0">
            <tr class="table-total-row">
              <td class="tabel-cell" style="font-weight: bold; font-size: 12px; background-color: #edf4f9;">Total</td>

              <ng-container *ngIf="modelSelectedAvg; else normalFooter">
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{modelTotalLeads}}</td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{modelTotalLeadAvg}}</td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{modelTotalCounts}}<span class="table-percentage"> ({{modelStagePercentage}}%)</span></td>
                <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{modelTotalCountAvg}}<span class="table-percentage"> ({{modelTotalCountAvgPer}}%)</span></td>
              </ng-container>

              <ng-template #normalFooter>
                <td class="tabel-cell"
                  style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">{{
                  modelTotalLeads }}</td>
                <td class="tabel-cell-per"
                  style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                  {{ modelTotalCounts }}<span class="table-percentage"> ({{ modelStagePercentage }}%)</span>
                </td>
              </ng-template>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>


<div class="graph row">
  <div class="col-8" style="width:68%">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="chart-head">Source Wise Performance</h1>
      <div class="comparison d-flex align-items-cente">
        <span *ngIf="!visibleSourceMonth" class="comparebtn" (click)="onclick3()">Compare
          <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
        </span>
        <div *ngIf="visibleSourceMonth" class="datepick d-flex align-items-cente">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpSourceStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="sourceStartMonth" placeholder="Select Month">
          </div>
          <span class="m-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpSourceEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="sourceEndMonth" placeholder="Select Month">
          </div>
          <div>
            <button class="btn compare" type="button" (click)="compareSourceAndSubSource()">
              <i class="fa fa-exchange-alt" title="Compare"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearSource()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-4">
        <ng-container *ngIf="sourceOptions.series.length != 0">
         <div style="overflow-x: auto; width: 100%; scroll-behavior: smooth;">
            <apx-chart #sourceChart [series]="sourceOptions.series!" [chart]="sourceOptions.chart!"
              [dataLabels]="sourceOptions.dataLabels!" [plotOptions]="sourceOptions.plotOptions!"
              [yaxis]="sourceOptions.yaxis!" [xaxis]="sourceOptions.xaxis!" [legend]="sourceOptions.legend!"
              [colors]="sourceOptions.colors!" [grid]="sourceOptions.grid!"></apx-chart>
          </div>
        </ng-container>
        <ng-container *ngIf="sourceOptions.series.length == 0">
          <div class="no-data-available">
            <img style="height: 280px;margin-left:40px" [src]="bucketurl + '/images/no-data-available.png'" alt="">
          </div>
        </ng-container>
      </div> -->
      <ng-container *ngIf="subSourceOptions.series.length != 0">
        <div style="overflow-x: auto; width: 100%; scroll-behavior: smooth;">
          <apx-chart #subSourceChart [series]="subSourceOptions.series!" [chart]="subSourceOptions.chart!"
            [dataLabels]="subSourceOptions.dataLabels!" [plotOptions]="subSourceOptions.plotOptions!"
            [yaxis]="subSourceOptions.yaxis!" [xaxis]="subSourceOptions.xaxis!" [legend]="subSourceOptions.legend!"
            [colors]="subSourceOptions.colors!" [grid]="subSourceOptions.grid!"></apx-chart>
        </div>
      </ng-container>
      <ng-container *ngIf="subSourceOptions.series.length == 0">
        <div class="no-data-available">
          <img style="height: 280px;margin-left:40px" [src]="bucketurl + '/images/no-data-available.png'" alt="">
        </div>
      </ng-container>
    </div>
    <!-- <div class="row" *ngIf="subSourceOptions.series.length == 0 && sourceOptions.series.length == 0">
      <div class=" no-data-available">
        <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
      </div>
    </div> -->
  </div>
  <div class="col-4 leads-status-box">
    <div *ngIf="isOneOutlet" class="avg-toggle-buttons d-flex justify-content-between align-items-center">
      <button type="button" class="avg-button" [class.active]="sourceSelectedAvg === 'national'"
        (click)="sourceSelectAvg('national')">
        National Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="nationalTemplate" />
      </button>
      <ng-template #nationalTemplate>
        The National Average is the total lost enquiries of selected source PAN india per Total outlets in Pan India.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="sourceSelectedAvg === 'zonal'"
        (click)="sourceSelectAvg('zonal')">
        Zonal Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="zonalTemplate" />
      </button>
      <ng-template #zonalTemplate>
        The Zonal Average is the total lost enquiries of selected source based on selected outlets zone per Total
        outlets in selected outlets zone.
      </ng-template>
      <button type="button" class="avg-button" [class.active]="sourceSelectedAvg === 'state'"
        (click)="sourceSelectAvg('state')">
        State Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The State Average is the total lost enquiries of Selected Source based on selected outlets states per Total
        outlets in selected outlets states
      </ng-template>
    </div>
    <div class="status-table">
      <div class="table-container">
        <table class="table right-table">
          <thead class="table-head">
            <tr>
              <ng-container *ngIf="sourceSelectedAvg; else normalSrcHeaderRow">
                <th rowspan="2" style="vertical-align: middle; text-align: left;border: 1px solid #ccc;"
                  class="table-head"> <img src="/assets/images/source-table.png" alt=""> Source</th>

                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/leads-table.png" alt=""> Enquiries
                </th>
                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/hot-table.png" alt=""> {{sourceSelectedField}}(%)
                </th>
              </ng-container>
            </tr>
            <tr *ngIf="sourceSelectedAvg">
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
            </tr>
            <ng-template #normalSrcHeaderRow>
              <th class="table-head"> <img src="/assets/images/source-table.png" alt=""> Source</th>
              <th class="table-head"><img src="/assets/images/leads-table.png" alt=""> Enquiries</th>
              <th class="table-head"><img src="/assets/images/hot-table.png" alt=""> {{sourceSelectedField}}(%)</th>
            </ng-template>
          </thead>
          <tbody class="table-body">
            <ng-container *ngIf="loadingTable4; else loadedContentSource">
              <ng-container *ngIf="!sourceSelectedAvg">
                <tr *ngFor="let i of [1, 2, 3, 4]">
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                </tr>
              </ng-container>
              <ng-container *ngIf="sourceSelectedAvg">
                <tr *ngFor="let i of [1, 2, 3, 4]">
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                  <td><ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader></td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #loadedContentSource>
              <tr *ngFor="let data of sourceStatus">
                <td class="tabel-cell">{{data.name}}</td>
                <ng-container *ngIf="sourceSelectedAvg; else normalSrcRow">
                  <td style="text-align: center;">{{ data.leads }}</td>
                  <td style="text-align: center;">{{ data.enqAverage }}</td>
                  <td style="text-align: center;">{{ data.count }} <span class="table-percentage"
                      *ngIf="data.percentage !== 0">({{ data.percentage }}%)</span></td>
                  <td style="text-align: center;">{{ data.stageAverage }} <span class="table-percentage"
                      *ngIf="data.stageAverage !== 0">({{ data.stageAveragePer }}%)</span></td>
                </ng-container>

                <ng-template #normalSrcRow>
                  <td class="tabel-cell" style="text-align: center;">{{data.leads}}</td>
                  <td class="tabel-cell-per" style="text-align: center;">{{data.count}} <span class="table-percentage"
                      *ngIf="data.percentage !== 0">({{ data.percentage }}%)</span></td>
                </ng-template>
              </tr>
              <tr *ngIf="sourceStatus?.length === 0">
                <td *ngIf="!sourceSelectedAvg" class="tabel-cell" colspan="3" style="text-align: center;">No data
                  available!</td>
                <td *ngIf="sourceSelectedAvg" class="tabel-cell" colspan="5" style="text-align: center;">No data
                  available!</td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot class="table-footer">
            <ng-container *ngIf="loadingTable4; else loadedFooter4">
              <tr>
                <td>
                  <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '10px' }"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ 'width': '60px', 'height': '10px', 'margin': 'auto' }"></ngx-skeleton-loader>
                </td>
                <td>
                  <ngx-skeleton-loader
                    [theme]="{ 'width': '60px', 'height': '10px', 'margin': 'auto' }"></ngx-skeleton-loader>
                </td>
              </tr>
            </ng-container>
            <ng-template #loadedFooter4>
              <tr *ngIf="sourceStatus?.length > 0" class="table-total-row">
                <td class="tabel-cell" style="font-weight: bold; font-size: 12px; background-color: #edf4f9;">Total</td>
                <ng-container *ngIf="sourceSelectedAvg; else normalSrcFooter">
                  <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{sourceTotalLeads}}</td>
                  <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{sourceTotalLeadAvg}}</td>
                  <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{sourceTotalCounts}}<span class="table-percentage"> ({{sourceStagePercentage}}%)</span></td>
                  <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{sourceTotalCountAvg}}<span class="table-percentage"> ({{sourceTotalCountAvgPer}}%)</span></td>
                </ng-container>
                <ng-template #normalSrcFooter>
                  <td class="tabel-cell"
                    style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{ sourceTotalLeads }}
                  </td>
                  <td class="tabel-cell-per"
                    style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{ sourceTotalCounts }}
                    <span class="table-percentage">({{ sourceStagePercentage }}%)</span>
                  </td>
                </ng-template>
              </tr>
            </ng-template>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="graph row mb-3">
  <div class="col-8" style="width:68%">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="chart-head">Lost Reason Performance</h1>
      <div class="comparison d-flex align-items-cente">
        <span *ngIf="!visibleLostMonth" class="comparebtn" (click)="onclick5()">Compare
          <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
        </span>
        <div *ngIf="visibleLostMonth" class="datepick d-flex align-items-cente">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpLostStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="lostStartMonth" placeholder="Select Month">
          </div>
          <span class="m-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpLostEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="lostEndMonth" placeholder="Select Month">
          </div>
          <div>
            <button class="btn compare" type="button" (click)="compareLost()">
              <i class="fa fa-exchange-alt" title="Compare"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearLost()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="lostReasonOptions.series.length > 0">
      <div style="overflow-x: auto; width: 100%; scroll-behavior: smooth;">
        <apx-chart #lostChart [series]="lostReasonOptions.series!" [chart]="lostReasonOptions.chart!"
          [dataLabels]="lostReasonOptions.dataLabels!" [plotOptions]="lostReasonOptions.plotOptions!"
          [yaxis]="lostReasonOptions.yaxis!" [xaxis]="lostReasonOptions.xaxis!" [legend]="lostReasonOptions.legend!"
          [colors]="lostReasonOptions.colors!" [grid]="lostReasonOptions.grid!"></apx-chart>
      </div>
    </ng-container>
    <ng-container *ngIf="lostReasonOptions.series.length == 0">
      <div class="no-data-available">
        <img [src]="bucketurl + '/images/no-data-available.png'" alt="">
      </div>
    </ng-container>
  </div>
  <div class="col-4 leads-status-box">
    <div *ngIf="isOneOutlet" class="avg-toggle-buttons d-flex justify-content-between align-items-center">
      <button type="button" class="avg-button" [class.active]="lostSelectedAvg === 'national'"
        (click)="lostSelectAvg('national')">
        National Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The National Average is the total enquiries of selected lost reason PAN india per Total outlets in Pan India
      </ng-template>
      <button type="button" class="avg-button" [class.active]="lostSelectedAvg === 'zonal'"
        (click)="lostSelectAvg('zonal')">
        Zonal Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The Zonal Average is the total enquiries of selected lost reason based on selected outlets zone per Total
        outlets in selected outlets zone. </ng-template>
      <button type="button" class="avg-button" [class.active]="lostSelectedAvg === 'state'"
        (click)="lostSelectAvg('state')">
        State Avg <img src="/assets/images/info.png" style="width:13px" alt="info" [adaptivePosition]="false"
          container="body" placement="left" containerClass="tooltipContainer" [tooltip]="stateTemplate" />
      </button>
      <ng-template #stateTemplate>
        The State Average is the total enquiries of eelected lost reason based on selected outlets states per Total
        outlets in selected outlets states
      </ng-template>
    </div>
    <div class="status-table" style="min-height:275px;max-height:275px !important">
      <div class="table-container" style="min-height:275px;max-height:275px !important">
        <table class="table right-table">
          <thead class="table-head">
            <tr>
              <ng-container *ngIf="lostSelectedAvg; else normalLostHeaderRow">
                <th rowspan="2" style="vertical-align: middle; text-align: left;border: 1px solid #ccc;"
                  class="table-head"> <img src="/assets/images/source-table.png" alt=""> Reason</th>
                <th colspan="2" class="table-head" style="text-align: center;border: 1px solid #ccc;">
                  <img src="/assets/images/leads-table.png" alt=""> Lost(%)
                </th>
              </ng-container>
            </tr>
            <tr *ngIf="lostSelectedAvg">
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Total</th>
              <th class="table-sub-head" style="text-align: center;position:sticky;top:30px;border: 1px solid #ccc;">
                Average</th>
            </tr>
            <ng-template #normalLostHeaderRow>
              <th class="table-head"> <img src="/assets/images/source-table.png" alt=""> Reasons</th>
              <!-- <th class="table-head"> <img src="/assets/images/source-table.png" alt=""> Lost</th> -->
              <th class="table-head"><img src="/assets/images/leads-table.png" alt=""> Lost(%)</th>
            </ng-template>
          </thead>
          <tbody class="table-body">
            <ng-container *ngIf="loadingTable5; else loadedContentLost">
              <ng-container *ngIf="!lostSelectedAvg">
                <tr *ngFor="let i of [1,2,3,4]">
                  <td>
                    <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                  <!-- <td>
                  <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                </td> -->
                  <td>
                    <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="lostSelectedAvg">
                <tr *ngFor="let i of [1,2,3,4]">
                  <td>
                    <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                  <!-- <td>
                    <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                  </td> -->
                  <td>
                    <ngx-skeleton-loader [theme]="{ 'width': '100%', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #loadedContentLost>
              <tr *ngFor="let data of lostStatus">
                <td class="tabel-cell">{{data.name}}</td>
                <!-- <td class="tabel-cell-per" style="text-align: center;">{{data.count}}</td> -->
                <ng-container *ngIf="lostSelectedAvg; else normalLostRow">
                  <td style="text-align: center;">{{ data.count }} <span class="table-percentage"
                      *ngIf="data.percentage !== 0"> ({{ data.percentage }}%)</span></td>
                  <td style="text-align: center;">{{ data.enqAverage }}
                    <!-- <span class="table-percentage" *ngIf="data.enqAveragePer !== 0"> ({{ data.enqAveragePer }}%)</span> -->
                  </td>
                </ng-container>
                <ng-template #normalLostRow>
                  <td class="tabel-cell-per" style="text-align: center;">{{data.count}} <span class="table-percentage"
                      *ngIf="data.percentage !== 0"> ({{ data.percentage }}%)</span></td>
                </ng-template>
              </tr>
              <tr *ngIf="lostStatus?.length === 0">
                <td *ngIf="!lostSelectedAvg" class="tabel-cell" colspan="2" style="text-align: center;">No data
                  available!</td>
                <td *ngIf="lostSelectedAvg" class="tabel-cell" colspan="3" style="text-align: center;">No data
                  available!</td>
              </tr>
            </ng-template>
          </tbody>
          <tfoot class="table-footer" *ngIf="lostStatus?.length > 0">
            <ng-container *ngIf="loadingTable5; else loadedFooter4">
              <ng-container *ngIf="!lostSelectedAvg">
                <tr>
                  <td *ngFor="let i of [1, 2]">
                    <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                </tr>
              </ng-container>
              <ng-container *ngIf="lostSelectedAvg">
                <tr>
                  <td *ngFor="let i of [1, 2, 3]">
                    <ngx-skeleton-loader [theme]="{ 'width': '80px', 'height': '10px' }"></ngx-skeleton-loader>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <ng-template #loadedFooter4>
              <tr class="table-total-row">
                <td class="tabel-cell" style="font-weight: bold;font-size: 12px;background-color: #edf4f9;">Total</td>
                <!-- <td class="tabel-cell" style="text-align: center; font-weight: bold;font-size: 12px;background-color: #edf4f9;">{{ lostTotalCounts }}</td> -->
                <ng-container *ngIf="lostSelectedAvg; else normalLostFooter">
                  <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{lostTotalCounts}}<span class="table-percentage"> ({{lostReasonPercentage}}%)</span></td>
                  <td style="text-align: center; font-weight: bold; font-size: 12px; background-color: #edf4f9;">
                    {{lostTotalLeadAvg}}
                    <!-- <span class="table-percentage"> ({{lostTotalCountAvgPer}}%)</span> -->
                  </td>
                </ng-container>
                <ng-template #normalLostFooter>
                  <td class="tabel-cell-per"
                    style="text-align: center; font-weight: bold;font-size: 12px;background-color: #edf4f9;">{{
                    lostTotalCounts }}
                    <span class="table-percentage"> ({{lostReasonPercentage}}%)</span>
                  </td>
                </ng-template>
              </tr>
            </ng-template>
          </tfoot>
        </table>
      </div>
    </div>
    <div class="status-legend">
      <div class="legend-item" *ngFor="let item of lostReasonToggle">
        <div class="slide-toggle-container">
          <label class="slide-toggle">
            <input type="checkbox" id="toggle" [(ngModel)]="item.checked" (change)="lostSlider(item, $event.target)">
            <span class="slider round"></span>
          </label>
          <span class="slider-label">{{item.reason}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- <div class="graph row mb-4">
  <div class="col-12">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="chart-head">Enquiry Vs Lost</h1>
      <div class="comparison d-flex align-items-cente">
        <span *ngIf="!visibleEnquiryMonth" class="comparebtn" (click)="onclick4()">Compare
          <img class="ml-2 logo-white" [src]="bucketurl + '/icons/calendar.png'" alt="">
        </span>
        <div *ngIf="visibleEnquiryMonth" class="datepick d-flex align-items-cente">
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpSourceStart="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="enquiryStartMonth" placeholder="Select Month">
          </div>
          <span class="m-2">To</span>
          <div>
            <input type="text" class="form-control" [bsConfig]="bsConfig" #dpSourceEnd="bsDatepicker" bsDatepicker
              readonly (keydown)="preventTyping($event)" [(bsValue)]="enquiryEndMonth" placeholder="Select Month">
          </div>
          <div>
            <button class="btn compare" type="button" (click)="compareLineChart()">
              <i class="fa fa-exchange-alt" title="Compare"></i>
            </button>
            <button class="btn btn-secondaryd clear" (click)="clearEnquiry()">
              <i class="fa fa-times-circle" title="Clear Comparison"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="chart-scroll-container">
        <apx-chart #lineChart [series]="enquiryOptions.series" [chart]="enquiryOptions.chart"
          [xaxis]="enquiryOptions.xaxis" [yaxis]="enquiryOptions.yaxis" [dataLabels]="enquiryOptions.dataLabels"
          [stroke]="enquiryOptions.stroke" [grid]="enquiryOptions.grid" [legend]="enquiryOptions.legend">
        </apx-chart>
      </div>
    </div>
  </div>
</div> -->

<ng-template #dateRangePicker>
  <h4 mat-dialog-title>
    Date Range
    <img class="close-button"  mat-dialog-close src="/assets/images/close.png"  alt="" (click)="reset()">
  </h4>
  <mat-dialog-content class="date-range-picker">
    <div class="date-range-picker__content">
      <div class="date-range-picker__sidebar">
        <button class="date-btn" mat-button class="sidebar-button" [class.selected]="selectedButton === 'today'"
          (click)="selectToday()">Today</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last7'"
          (click)="selectLast7Days()">Last 7 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'last15'"
          (click)="selectLast15Days()">Last 15 days</button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'thisMonth'"
          (click)="selectThisMonth()"><span *ngIf="isDateOne">Last Month</span><span *ngIf="!isDateOne">This
            Month</span></button>
        <button mat-button class="sidebar-button" [class.selected]="selectedButton === 'custom'"
          (click)="selectCustom()">Custom</button>
      </div>
      <div class="date-range-picker__main" [ngClass]="{ 'isDateCustom': selectedButton != 'custom'}">
        <mat-calendar (selectedChange)="selectedChange($event)" [maxDate]="today" [selected]="dateRange"
          #startCalendar></mat-calendar>
      </div>
    </div>

    <div mat-dialog-actions class="d-flex justify-content-between align-items-center">
      <div class="date-display">
        <span class="date-label" *ngIf="startDate">From:</span> <span class="date-value">{{startDate |
          date:'dd-MMM-yyyy'}}</span>
        <span class="date-label ml-2" *ngIf="endDate">To:</span> <span class="date-value">{{endDate |
          date:'dd-MMM-yyyy'}}</span>
      </div>
      <div>
        <button #cancelButton class="btn white-btn mr-2" type="button" (click)="closeDialog()">Cancel</button>
        <button class="btn blue-btn" type="submit" (click)="applyDateRange()">Apply</button>
      </div>
    </div>
  </mat-dialog-content>
</ng-template>